import { useMemo } from 'react';

import { Country } from '@electricjs/arc';

import { useStorefront } from '../StorefrontProvider';
import {
  getCatalogEstimatedDeliveryDate,
  getCatalogEstimatedShipDate,
} from './helpers';

/** Hook to get the current estimated dates (ship/delivery) of a catalog purchase in storefront */
export const useCurrentCatalogEstimatedDates = () => {
  const {
    storefrontCheckoutForm,
    canConfigureWinZtp,
    canConfigureWinAutopilot,
  } = useStorefront();

  const selectedCatalogShippingMethod = storefrontCheckoutForm?.watch(
    'catalogShippingMethod'
  );

  const selectedShoppingCountry =
    storefrontCheckoutForm?.watch('shoppingCountry');

  const shoppingCountryCode =
    selectedShoppingCountry && selectedShoppingCountry?.value !== 'other'
      ? selectedShoppingCountry.value
      : ('US' as Country);

  const windowsZtpEnabled =
    storefrontCheckoutForm?.watch('windowsZtpEnabled') ?? false;

  const wAutopilotEnabled =
    storefrontCheckoutForm?.watch('wAutopilotEnabled') ?? false;
  const wAutopilotMsTenantId = storefrontCheckoutForm?.watch(
    'wAutopilotMsTenantId'
  );

  const estimatedDates = useMemo(() => {
    if (!selectedCatalogShippingMethod) {
      return;
    }

    const today = new Date();

    const hasZtpHandling = canConfigureWinZtp && windowsZtpEnabled;

    const hasWAutopilotHandling =
      canConfigureWinAutopilot && wAutopilotEnabled && !!wAutopilotMsTenantId;

    const shipDate = getCatalogEstimatedShipDate(
      today,
      hasZtpHandling,
      hasWAutopilotHandling
    );

    const deliveryDate = getCatalogEstimatedDeliveryDate(
      shipDate,
      shoppingCountryCode,
      selectedCatalogShippingMethod.value
    );

    return {
      shipDate,
      deliveryDate,
    };
  }, [
    selectedCatalogShippingMethod,
    shoppingCountryCode,
    canConfigureWinZtp,
    windowsZtpEnabled,
    canConfigureWinAutopilot,
    wAutopilotEnabled,
    wAutopilotMsTenantId,
  ]);

  return estimatedDates;
};
